<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('studentEnrollment.updateClass') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <div class="row form-group">
        <div class="col-md-12">
          <label>{{ $t('studentEnrollment.studentName') }}</label>
          <input
            type="text"
            class="form-control"
            readonly
            :value="edit_data.student_profile.full_name_en"
          />
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label>{{ $t('studentEnrollment.className') }}</label>
          <input
            type="text"
            class="form-control"
            readonly
            :value="
              edit_data.academic_class.class_name +
                ' | ' +
                edit_data.academic_class.teacher.fname_foreign +
                ' ' +
                edit_data.academic_class.teacher.lname_foreign +
                ' | ' +
                edit_data.academic_class.academic_study_time.study_time
            "
          />
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{ $t('studentEnrollment.newClass') }}</label>
          <treeselect
            :load-options="loadOptions"
            :multiple="false"
            :options="options"
            :placeholder="$t('select')"
            :maxHeight="120"
            openDirection="top"
            v-model.number="model.new_class_id"
          />
          <div class="validate" v-if="errors.has('new_class_id')">
            {{ errors.first('new_class_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right mt-2">
          <ts-button
            class="primary"
            color="primary"
            :waiting="waiting"
            @click="update"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'

export default {
  name: 'updateClassTeaching',
  props: ['edit_data'],
  data() {
    return {
      model: {
        st_class_id: '',
        student_id: '',
        old_class_id: '',
        new_class_id: null
      },
      options: null,
      errors: new Errors(),
      waiting: false
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    ...mapActions('studentEnrollment', ['getClassOperation']),
    setEditData() {
      this.model = {
        st_class_id: this.edit_data.st_class_id,
        student_id: this.edit_data.student_id,
        old_class_id: this.edit_data.class_id,
        new_class_id: null
      }
    },
    async loadOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.options = null
        await this.getClassOperation({
          filter: {
            grade_id: this.edit_data.academic_class.grade_id,
            ac_status_id: '1,3'
          },
          page: -1
        })
          .then(response => {
            this.options = response.data.map(el => ({
              id: el.class_id,
              label: `${el.class_name} | ${el.room_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}`
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    update() {
      this.waiting = true
      this.$store
        .dispatch('studentEnrollment/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('before-close')
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
